import { render, staticRenderFns } from "./AccountSettingsGeneralInfo.vue?vue&type=template&id=bd5fc65e&"
import script from "./AccountSettingsGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports